import React, { useState } from "react";

import { connect } from "react-redux";

import { useQuery, useLazyQuery } from "@apollo/client";
import { downloadExcel, downloadPDF } from "../../../utils/generalUtils";

import Structure from "../../../components/Base/Structure";

import ASSETS_BYGROUPS_QUERY from "../../../graphql/queries/assetByGroupsQuery";
import FLEET_KM_REPORT from "../../../graphql/queries/getFleetKmReport";
import FLEET_KM_REPORT_EXPORT from "../../../graphql/queries/getFleetKmReportExportQuery";

import Filter from "./Filter";
import ReportResult from "./ReportResult";

import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

import PageTitle from "../../../components/Base/PageTitle";
import { useFilterValidation } from "../useFilterValidation";

import { useTranslation } from "../../../lang";
import { localDateTimeStringToUTC } from "../../../utils/dates";

const FleetKmReport = ({ selectedGroups }) => {
  const [t] = useTranslation();
  const [assetList, setAssetList] = useState([]);
  const [exportSelected, setExportSelected] = useState("EXCEL");

  const [assetTableState, setAssetTableState] = useState({
    searchText: "",
    sort: undefined,
    paginate: false,
  });

  const [reportResult, setReportResult] = useState([]);

  const [resultState, setResultState] = useState({
    isOpen: false,
    type: "success",
    msg: "",
  });

  const {} = useQuery(ASSETS_BYGROUPS_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      groupIDs: selectedGroups.filter(
        (g) => g && !Number.isNaN(Number.parseInt(g))
      ),
      ...assetTableState,
    },
    onCompleted(d) {
      const { count, items } = d.assetsByGroups;
      //setTotal(count);
      setAssetList(items.map((a) => ({
        ...a,
        completeName: `${a.name} - ${a.licensePlate}`
      })));
    },
  });

  const [fetchReport] = useLazyQuery(FLEET_KM_REPORT, {
    fetchPolicy: "network-only",
    onCompleted(d) {
      if (d.fleetKmReport) setReportResult(d.fleetKmReport);
      else {
        setReportResult(null);
        setResultState({
          isOpen: true,
          type: "info",
          msg: t("No se encontraron datos para su consulta"),
        });
      }
    },
    onError(err) {
      setResultState({
        isOpen: true,
        type: "error",
        msg: err.message,
      });
    },
  });

  const [getExport] = useLazyQuery(FLEET_KM_REPORT_EXPORT, {
    fetchPolicy: "network-only",
    onCompleted(d) {
      const filename = t("ReporteKmFlota");
      switch (exportSelected) {
        case "EXCEL":
          downloadExcel(d.fleetKmReportExport, filename);
          break;
        case "PDF":
          downloadPDF(d.fleetKmReportExport, filename);
          break;
      }
    },
  });

  const handleSearchReportFleetKmReport = ({
    assetsSelected,
    fechaDesde,
    fechaHasta,
    dias,
  }) => {
    fetchReport({
      variables: {
        assetsSelected: assetsSelected,
        fechaInicio: localDateTimeStringToUTC(fechaDesde),
        fechaFin: localDateTimeStringToUTC(fechaHasta),
        days: dias,
      },
    });
  };

  const { handleSearchReport, errors: filterErrors } = useFilterValidation(
    handleSearchReportFleetKmReport
  );

  const handleExportExcel = (assetsSelected, fechaDesde, fechaHasta, dias) => {
    setExportSelected("EXCEL");
    getExport({
      variables: {
        assetsSelected: assetsSelected,
        fechaInicio: localDateTimeStringToUTC(fechaDesde),
        fechaFin: localDateTimeStringToUTC(fechaHasta),
        days: dias,
        format: "EXCEL",
      },
    });
  };

  const handleExportPDF = (assetsSelected, fechaDesde, fechaHasta, dias) => {
    setExportSelected("PDF");
    getExport({
      variables: {
        assetsSelected: assetsSelected,
        fechaInicio: localDateTimeStringToUTC(fechaDesde),
        fechaFin: localDateTimeStringToUTC(fechaHasta),
        days: dias,
        format: "PDF",
      },
    });
  };

  const handleCloseNotification = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setResultState({
      ...resultState,
      isOpen: false,
    });
  };

  return (
    <Structure>
      <Snackbar
        open={resultState.isOpen}
        autoHideDuration={5000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseNotification}
          severity={resultState.type}
          variant="filled"
        >
          {resultState.msg}
        </MuiAlert>
      </Snackbar>
      <PageTitle sector={t("Estadísticas")} title={t("Kilometraje de Flota")} />
      <Filter
        assets={assetList}
        searchReport={handleSearchReport}
        handleExportExcel={handleExportExcel}
        handleExportPDF={handleExportPDF}
        errors={filterErrors}
        reportResult={Array.isArray(reportResult) && reportResult.length > 0}
      />
      {Array.isArray(reportResult) && reportResult.length > 0 && (
        <ReportResult reportData={reportResult} />
      )}
    </Structure>
  );
};

const _mapStateToProps = ({ groups }) => {
  return {
    selectedGroups: groups.selectedGroups,
  };
};

export default connect(_mapStateToProps, null)(FleetKmReport);
